import { render, staticRenderFns } from "./ExceptionsTable.vue?vue&type=template&id=642da97a"
import script from "./ExceptionsTable.vue?vue&type=script&lang=js"
export * from "./ExceptionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports